module.exports = __webpack_public_path__ + "static/media/life.accf5b4.mp4";


//////////////////
// WEBPACK FOOTER
// ./static/video/life.mp4
// module id = 5c97
// module chunks = 1